export default "__VITE_ASSET__BdZMgEs$__"